import { Part, Heading, StyledButton, Caption, Text, SubText, OtherSourcesSection, OtherSourcesHeading, SourceList, SourceItem, SourceTitle, SourceDescription } from './WhereIsMyVin.styles';
import getAssetUrl from 'utilities/getAssetUrl';

type WhereIsMyVinProps = {
  closeModal?: () => void;
};

const WhereIsMyVin = ({ closeModal }: WhereIsMyVinProps) => (
  <>
    <Heading>Where is my VIN?</Heading>
    <Part>
      <img src={getAssetUrl('/images/vin-windshield.png')} alt="vin in windshield" />
      <Caption>
        <Text>Driver side dashboard</Text>
        <SubText>Where the dashboard meets the windshield</SubText>
      </Caption>
    </Part>
    <Part>
      <img src={getAssetUrl('/images/vin-door.png')} alt="vin in door" />
      <Caption>
        <Text>Driver side door jamb</Text>
        <SubText>On the inside frame of the driver's door</SubText>
      </Caption>
    </Part>
    <OtherSourcesSection>
      <OtherSourcesHeading>Other ways to find your VIN</OtherSourcesHeading>
      <SourceList>
        <SourceItem>
          <SourceTitle>Vehicle registration:</SourceTitle> <SourceDescription>Your state registration paperwork, often available through your DMV's website or app.</SourceDescription>
        </SourceItem>
        <SourceItem>
          <SourceTitle>Insurance documents:</SourceTitle> <SourceDescription>Your auto insurance policy, ID card or online account.</SourceDescription>
        </SourceItem>
        <SourceItem>
          <SourceTitle>Title or lien documents:</SourceTitle> <SourceDescription>On your electronic or paper title. You can also access it from your lender's account.</SourceDescription>
        </SourceItem>
      </SourceList>
    </OtherSourcesSection>
    <StyledButton className="where-is-my-vin" variant="primary" size="md" onClick={closeModal}>
      Okay
    </StyledButton>
  </>
);

export default WhereIsMyVin;
